// sentry.ts
import * as Sentry from "@sentry/react";
import { getSentry } from "./environment";
// Import the version info generated by the build script
// @ts-ignore
import { BUILD_VERSION } from "./versioning/version";
import { detectClientPlatform } from "./utils/detectClientPlatform";

const initSentry = () => {
  if (window.location.origin.includes("localhost")) {
    return;
  }

  Sentry.init({
    dsn: getSentry(),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    ignoreErrors: [/\bInvariant\b/i, /\bsave failed\b/i],
    tracesSampleRate: 1.0,
    maxValueLength: 20000,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: BUILD_VERSION.version, // Use the build version as the release\
  });

  // Add a breadcrumb with build information
  Sentry.addBreadcrumb({
    category: "app",
    message: "Application started",
    level: "info",
    data: {
      buildNumber: BUILD_VERSION.buildNumber,
      buildDate: BUILD_VERSION.buildDate,
      platform: detectClientPlatform(),
      version: BUILD_VERSION.version,
    },
  });
};

export default initSentry;
